/**
 * Stats Block Block JavaScript
 */

(function () {
  "use strict";

  // Initialize block functionality
  function initStatsBlock() {
    const blocks = document.querySelectorAll(".stats-block");

    blocks.forEach((block) => {
      initCountUpAnimation(block);
    });
  }

  /**
   * Initialize GSAP count-up animation for stat numbers
   */
  function initCountUpAnimation(block) {
    // Wait for GSAP to be available
    let retryCount = 0;
    const maxRetries = 50;

    function checkGSAP() {
      retryCount++;

      let gsapLib = null;
      let scrollTrigger = null;

      if (typeof gsap !== "undefined") {
        gsapLib = gsap;
      } else if (typeof window.gsap !== "undefined") {
        gsapLib = window.gsap;
      }

      if (typeof ScrollTrigger !== "undefined") {
        scrollTrigger = ScrollTrigger;
      } else if (typeof window.ScrollTrigger !== "undefined") {
        scrollTrigger = window.ScrollTrigger;
      }

      if (!gsapLib || !scrollTrigger) {
        if (retryCount < maxRetries) {
          setTimeout(checkGSAP, 100);
          return;
        } else {
          return;
        }
      }

      // Find all stat number elements
      const statNumbers = block.querySelectorAll(".stat-number[data-target]");

      statNumbers.forEach((statElement) => {
        const targetValue = parseFloat(statElement.dataset.target);
        if (isNaN(targetValue)) return;

        // Extract number from the target (handle cases like "1,000" or "1.5M")
        const cleanNumber = parseFloat(
          targetValue.toString().replace(/[^\d.]/g, "")
        );
        if (isNaN(cleanNumber)) return;

        // Store original suffix/prefix if needed
        const suffix = statElement.nextElementSibling?.classList.contains(
          "stat-suffix"
        )
          ? statElement.nextElementSibling.textContent
          : "";
        const prefix = statElement.previousElementSibling?.classList.contains(
          "stat-prefix"
        )
          ? statElement.previousElementSibling.textContent
          : "";

        // Format number function
        const formatNumber = (num) => {
          // Check if original had commas or special formatting
          const original = statElement.dataset.target;
          if (original.includes(",")) {
            return Math.floor(num).toLocaleString();
          }
          // Check for decimal places
          const decimals = original.split(".")[1]?.length || 0;
          return num.toFixed(decimals);
        };

        // Create counter animation with ScrollTrigger
        const counter = { value: 0 };
        const statItem = statElement.closest(".stat-item");
        let hasAnimated = false;
        let wasIntersecting = false;
        let observerInitialized = false;
        
        // Set initial value to 0
        statElement.textContent = formatNumber(0);

        // Use IntersectionObserver to ensure animation only triggers when scrolling into view
        // Track previous intersection state to only trigger on entry, not on initial load
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isIntersecting = entry.isIntersecting;
              
              // On first observation, check if element is already visible
              if (!observerInitialized) {
                observerInitialized = true;
                wasIntersecting = isIntersecting;
                // If already visible on first check, don't trigger - wait for scroll
                if (isIntersecting) {
                  return;
                }
              }
              
              // Only trigger if:
              // 1. Element is currently intersecting
              // 2. It wasn't intersecting before (entering viewport)
              // 3. Animation hasn't run yet
              if (isIntersecting && !wasIntersecting && !hasAnimated) {
                hasAnimated = true;
                // Element is entering view - trigger animation
                gsapLib.to(counter, {
                  value: cleanNumber,
                  duration: 2,
                  ease: "power2.out",
                  onUpdate: function () {
                    const formatted = formatNumber(counter.value);
                    statElement.textContent = formatted;
                  },
                  onComplete: function() {
                    // Stop observing after animation completes
                    observer.unobserve(statItem);
                  }
                });
              }
              
              // Update previous state
              wasIntersecting = isIntersecting;
            });
          },
          {
            threshold: 0.3, // Trigger when 30% of element is visible
            rootMargin: "0px 0px -10% 0px", // Start slightly before fully in view
          }
        );
        
        // Observe the stat item
        observer.observe(statItem);
      });
    }

    checkGSAP();
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStatsBlock);
  } else {
    initStatsBlock();
  }
})();
